/**
 * Skill Catalog & User Skills
 *
 * Master skill catalog (admin-curated + user-submitted custom skills, moderated),
 * and a user's catalog-linked skill claims — self-declared proficiency plus any peer
 * endorsements and assessment-based verification earned against it. This is also the
 * resume/profile skill list (yearsOfExp + sortOrder drive resume presentation).
 */
export var SkillStatus;
(function (SkillStatus) {
    SkillStatus["APPROVED"] = "APPROVED";
    SkillStatus["PENDING"] = "PENDING";
    SkillStatus["REJECTED"] = "REJECTED";
})(SkillStatus || (SkillStatus = {}));
